import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import MarketingNav from "@/components/MarketingNav";
import api from "@/lib/api";
import { Globe } from "lucide-react";

const STAGES = [
  "Asking ChatGPT…",
  "Asking Claude…",
  "Asking Gemini…",
  "Analysing mentions…",
  "Building your atlas…",
];

export default function AtlasScanning() {
  const { atlas_id } = useParams();
  const navigate = useNavigate();
  const [stage, setStage] = useState(0);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    document.title = "Scanning · AI Visibility Atlas";
    let cancelled = false;
    let pollInterval = 0;
    let stageInterval = 0;

    stageInterval = window.setInterval(() => {
      setStage((s) => (s + 1) % STAGES.length);
    }, 2500);

    const poll = async () => {
      try {
        const r = await api.get(`/public/atlas/status/${atlas_id}`);
        if (cancelled) return;
        if (r.data.status === "completed") {
          navigate(`/atlas/${r.data.country_slug}/${r.data.slug}`, { replace: true });
        } else if (r.data.status === "failed") {
          setFailed(true);
        }
      } catch {
        setFailed(true);
      }
    };
    poll();
    pollInterval = window.setInterval(poll, 3500);

    return () => {
      cancelled = true;
      window.clearInterval(pollInterval);
      window.clearInterval(stageInterval);
    };
  }, [atlas_id, navigate]);

  return (
    <div className="bg-white min-h-screen" data-testid="atlas-scanning">
      <MarketingNav />
      <section className="max-w-3xl mx-auto px-6 py-24 text-center">
        <div className="w-14 h-14 mx-auto rounded-full border-2 border-zinc-200 border-t-zinc-900 animate-spin" />
        <h1 className="display mt-8 text-4xl font-black tracking-tighter">
          Building your atlas
        </h1>
        <p className="mt-4 text-zinc-600 text-sm">
          Typical scan time: 30–60 seconds. You'll be redirected when your
          atlas is ready.
        </p>
        {!failed ? (
          <div
            className="mt-8 pill"
            data-testid={`stage-${stage}`}
          >
            <Globe size={11} /> {STAGES[stage]}
          </div>
        ) : (
          <div
            className="mt-8 inline-flex items-center gap-2 text-sm text-rose-700 bg-rose-50 border border-rose-200 rounded-[4px] p-3"
            data-testid="atlas-scan-failed"
          >
            Scan failed. Please try again in a moment.
          </div>
        )}
      </section>
    </div>
  );
}
